<template>
  <div class="menu-list">
       <div class="animated fadeIn">
         <b-row>
          <b-col cols="12">
            <div class="form-group row header-custom-switch">
              <div class="col-sm-10 col-form-label uppercase">
                <strong>
                  <h3>
                    <router-link :to="{ name: 'outlets_edit', params: { uuid: this.$route.params.uuid }}" class="float-left mr-1 main-link">
                    {{$t('store.store_profile')}}
                    </router-link>
                    / 
                    {{ $t('store.tradezone_list') }}
                  </h3>
                </strong>
              </div>
            </div>
          </b-col>
        </b-row> 
        <b-row>
            <b-col cols="12">
            <b-card
                header-tag="header"
                footer-tag="footer">
                <div slot="header">
                <i className="fa fa-align-justify"></i><strong class="text-uppercase">{{ $t('store.manage_tradezone') }}</strong>
                </div>
                <b-col cols="12" class="text-center">
                <b-row class="pull-right">
                    <b-col cols="12">

                    <!-- <b-input-group>
                        <select-dropdown v-bind:options="filter.options" v-bind:selected="filter.selected" position="prepend" v-bind:all="false" v-model="filter.field" prefix="store">
                        </select-dropdown>
                        <input type="text" class="form-control" v-model="filter.key" v-on:keydown.enter="refreshData"/>
                        <div class="input-group-append">
                        <b-input-group-append>
                            <b-btn @click="refreshData()"><i class="fa fa-search" ></i> {{$t('common.search')}}</b-btn>
                        </b-input-group-append>
                        </div>
                    </b-input-group> -->
                    </b-col>
                </b-row>

                <div class="table-responsive outlet-data">
                    <table class="table table-striped table-hover table-sm table-bordered">
                    <thead>
                    <tr>
                        <th v-if="this.client == 122"><span>{{$t('store.tradezone_area_id')}}</span></th>
                        <th v-if="this.client == 122"><span>{{$t('store.tradezone_area_name')}}</span></th>
                        <th v-if="this.client == 122"><span>{{$t('store.tradezone_block_name')}}</span></th>
                        <th scope="col" :class="item.sort?'pointer':''" v-for="item in dataTable.fields" :key="item.tradezone_id" @click="updateSort(item.name)">
                        <i class="fa fa-sort-amount-asc text-muted" v-if="dataTable.sort.type == 'asc' && dataTable.sort.field == item.name"></i>
                        <i class="fa fa-sort-amount-desc text-muted" v-if="dataTable.sort.type == 'desc' && dataTable.sort.field == item.name"></i>
                        <span v-if="item.label != null">{{$t('store.'+item.label)}}</span>
                        <span v-if="item.label == null">{{$t('store.'+item.name)}}</span>
                        </th>
                        <th v-show="outlet_config.config.support_subtradezone" scope="col" style="min-width: 175px">{{$t('store.subtradezone_action')}}</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-if="dataTable.items.length == 0">
                        <td class="text-center" :colspan="dataTable.fields.length + 4">
                        {{$t('message.no_data')}}
                        </td>
                    </tr>
                    <tr v-for="item in dataTable.items" :key="item.tradezone_id">
                        <td v-if="client == 122" scope="row" class="text-left">
                           <span>{{item['address_code']}}</span>
                        </td>
                        <td v-if="client == 122" scope="row" class="text-left">
                           <span>{{item['area_name']}}</span>
                        </td>
                        <td v-if="client == 122" scope="row" class="text-left">
                           <span>{{item['block_name']}}</span>
                        </td>
                        <td scope="row" class="text-center" v-for="field in dataTable.fields" :key="field.tradezone_id">
                          <a v-if="field.render != null && field.name == 'is_wellformed' && item[field.name] == 0" style='color:#ef2929; font-size: 16px;' href="https://dev.mysql.com/doc/refman/5.7/en/geometry-well-formedness-validity.html" target="_blank" >
                              <i class="fa fa-exclamation-circle"></i>&nbsp;<span style="font-size: 14px;">{{$t('store.non_wellformed_learn_more')}}</span>
                          </a>
                           <span v-if="field.render != null && field.name == 'is_wellformed' && item[field.name] == 1" style='color:#20c520; font-size: 16px;' >
                              <i class="fa fa-check"></i>
                          </span>
                          <span v-if="field.render != null && field.name != 'tradezone_map' && field.name != 'is_wellformed'" v-html="field.render(item[field.name], item)"></span>
                          <span v-if="field.render != null && field.name == 'tradezone_map'">
                            <b-button size="sm" :class="'draw-map'" @click="openMap(item)" :variant="'primary'">
                                <strong>{{$t('store.view_tradezone_map')}}</strong>
                            </b-button>
                            <span class="d-inline-block col-1 remove-section" >
                              <i class="fa fa-trash-o text-main pointer" @click="removeTradezone(item['tradezone_id'])" ></i>
                            </span>
                          </span>
                          <span v-if="field.render == null">
                              {{item[field.name]}}
                          </span>
                        </td>
                        <td scope="row" v-show="outlet_config.config.support_subtradezone">
                        <b-button size="sm" variant="primary" v-on:click="editItem(item['tradezone_id'])">
                            <i class="fa fa-edit"></i> {{$t('store.subtradezone_action')}}
                        </b-button>
                        <label class="file-select">
                            <div class="select-button">
                            <span>{{$t('store.subtradezone_upload')}}</span>
                            </div>
                            <b-form-file  :ref="'file-' + item.tradezone_id.toString()" :id="item.tradezone_id.toString()" class="mb-2" accept=".kml" @change="uploadKmlFile" plain></b-form-file>                         
                            <!-- <input style="height:34px;width:141px;" ref="kmlFile" type="file" @change="uploadKmlFile" /> -->
                        </label>
                        <!-- <b-col cols="2" class="text-right remove-section" >
                              <i class="fa fa-trash-o text-main pointer" @click="removeTradezone(item['tradezone_id'])" ></i>
                        </b-col> -->
                        </td>
                    </tr>
                    </tbody>
                    </table>
                </div>
                <b-row>
                    <b-col>
                    <b-pagination :total-rows="dataTable.total" :per-page="dataTable.perPage" v-model="dataTable.currentPage" />
                    </b-col>
                    <b-col class="text-left">
                    {{$t('message.datatable_total', {number: dataTable.items.length, total: dataTable.total})}}
                    </b-col>
                    <b-col col lg="1">
                    <b-form-select v-model="dataTable.perPage" :options="[10, 20, 50, 100]" class="mb-3"/>
                    </b-col>
                </b-row>
                </b-col>
            </b-card>
            </b-col>
        </b-row>
       </div>
        <!-- New Map -->
        <b-modal ref="newMap" v-bind:title="$t('store.draw_map')" size="lg" body-class="padding-none" :hide-header="false"
                :hide-footer="true">
         <outlet-map v-bind:lat="item.lat" v-bind:long="item.long" v-bind:markers="markers" @paths="paths = $event"
                  v-bind:getpaths="paths" v-bind:subpaths="subpaths"></outlet-map>
        </b-modal>

        <!-- Notification for add address -->
        <b-modal ref="notiMap" v-bind:title="$t('store.noti_draw_map')" size="lg">
        {{$t('store.noti_draw_map')}}
        </b-modal>
        <!--  -->
        <!-- End New map -->
  </div>
</template>

<script>
import SelectDropdown from '../../../components/Partials/SelectDropdown'
import DataTable from '../../../components/Partials/DataTable'
import DateRangePicker from 'vue2-daterange-picker'
import axios from 'axios'
import cSwitch from '../../../components/Switch'
import OutletMap from '../outlets/OutletsMap.vue'

const isQGISFile = async (file) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsText(file, "UTF-8");
    reader.onload = evt => {
      const content = evt.target.result || '';
      resolve(content.includes("<Schema"));
    }
  });
}

const CancelToken = axios.CancelToken
let cancel = null
let vm = null
export default {
  name: 'TradezoneList',
  components: {
    SelectDropdown,
    DateRangePicker,
    cSwitch,
    DataTable,
    OutletMap
  },
  data: function () {
    return {
      client: 0,
      outlet_config: {},
      type: 'like',
      statuses: [],
      OutletsListCode: [],
      filter: {
        options: [],
        selected: null,
        status: 1,
        code: '',
        field: null,
        key: null,
      },
      lat: 0,
      long: 0,
      paths: [],
      subpaths: [],
      center: {lat: 0, lng: 0},
      markers: [{
        position: {lat: 0, lng: 0},
        label: '',
        draggable: false,
        title: ''
      }],
      dataTable: {
        items: [],
        fields: [
             {
            name: 'code',
            label: 'outlet_code',
            filter: true,
            sort: true,
            render: (data, row) => {
              if (data == null) {
                return ''
              }
              return data
            }
          },
          {
            name: 'name',
            label: 'outlet_name',
            filter: true,
            sort: true,
            render: (data, row) => {
              if (data == null) {
                return ''
              }
              return data[this.$session.get('lang')]
            }
          },
          {
            name: 'area_code',
            filter: false,
            sort: false,
            render: (data, row) => {
              if (data == null) {
                return ''
              }
              return data
            }
          },
          {
            name: 'tradezone_from_date',
            filter: false,
            sort: true,
            render: (data, row) => {
              if (data == null) {
                return ''
              }
              return this.$moment(data).format('YYYY-MM-DD')
            }
          },
          {
            name: 'tradezone_to_date',
            filter: false,
            sort: false,
            render: (data, row) => {
              if (data == null) {
                return ''
              }
              return this.$moment(data).format('YYYY-MM-DD')
            }
          },
          {
            name: 'is_wellformed',
            filter: false,
            sort: false,
            render: (data, row) => {
              if (data == null) {
                return ''
              }
              return data
            }
          },
           {
            name: 'tradezone_map',
            filter: false,
            sort: false,
            render: (data, row) => {
              if (data == null) {
                return ''
              }
              return data
            }
          },
           
        ],
        sort: {
          field: 'updated_at',
          type: 'desc'
        },
        currentPage: 1,
        total: 0,
        perPage: 20,
        source: null
      },
      item: {}
    }
  },
 
  methods: {
    updateSort: function (field) {
      for (let i in this.dataTable.fields) {
        if (this.dataTable.fields[i].name == field && (this.dataTable.fields[i].sort == null || this.dataTable.fields[i].sort == false)) {
          return
        }
      }
      if (this.dataTable.sort.field != field) {
        this.dataTable.sort = {
          field: field,
          type: 'asc'
        }
      } else {
        if (this.dataTable.sort.type == 'asc') {
          this.dataTable.sort = {
            field: field,
            type: 'desc'
          }
        } else {
          this.dataTable.sort = {
            field: field,
            type: 'asc'
          }
        }
      }

      this.refreshData()
    },

    openMap: function (item) {
        const { subtradezones = [], coords = [] } = item;

        if (item.lat !== null && item.long !== null) {
            var position = {lat: item.lat, lng: item.long}
            vm.$set(vm.item, 'id', item.id)
            vm.$set(vm.item, 'code', item.code)
            vm.$set(vm.item, 'client_id', item.client_id)
            vm.$set(vm.item, 'lat', item.lat)
            vm.$set(vm.item, 'long', item.long)
            vm.paths = [{id: item.id, coords: coords || []}]
            vm.subpaths = subtradezones ? subtradezones.map(
              item => { 
                return {
                  coords: item.coords,
                  is_delivery: item.is_delivery,
                  id: item.id,
                  delivery_fee: item.delivery_fee,
                  delivery_time: item.delivery_time,
                  name: item.subtradezone_name,
                  business_hours: item.business_hours
                }
              }
            ) : []
            vm.markers.push({position: position, label: '', draggable: false, title: ''})
            this.$refs.newMap.show()
            this.$root.$emit('bv::show::modal')
        } else {
          this.$refs.notiMap.show()
        }
    },
    uploadKmlFile: async function (event) {
        let input = event.target
        let tradezoneId = parseInt(input.id);
        if (input.files) {
            const file = input.files[0]
            const isQGIS = await isQGISFile(file)
            let formData = new FormData()
            formData.append('file', file)
            formData.append('tradezone_id', tradezoneId)
            if (isQGIS) formData.append('format', 'qgis')
            let config = {headers: {'Content-Type': 'multipart/form-data'}}

            // Just market Mexico (clientId = 131)
            // accepte Google KML file, the remaining markets accept QGIS KML file
            const checkedClientIds = [131];
            if (!checkedClientIds.includes(this.client) && !isQGIS) {
              vm.$toastr.error(vm.$t('tradezone_kml_upload.invalid_qgis_kml'))
            } else if (checkedClientIds.includes(this.client) && isQGIS) {
              vm.$toastr.error(vm.$t('tradezone_kml_upload.invalid_google_kml'))
            } else {
              //call an API to save csv file
              vm.$bus.$emit('loading', 'block')
              vm.axios.outlet.importSubTradezoneKML(formData, config, function (response) {
                  vm.$toastr.success(vm.$t('message.update_successful'), vm.$t('message.success'), {})
                  vm.$bus.$emit('loading', 'none')
                  vm.$refs['file-'+ tradezoneId][0].$el.value = null;
                  vm.$refs['file-'+ tradezoneId].reset();
              }, function () {
                  vm.$toastr.error(vm.$t('message.error'), vm.$t('message.success'), {})
                  vm.$bus.$emit('loading', 'none')
              })
            }
        }
    },
    /**
     * Refesh data
    */
    refreshData: function () {
      let uuid = this.$route.params.uuid;
      
      if (cancel != null) {
        cancel()
      }
      let search = ''
      if (!this._.isEmpty(this.filter.field) && !this._.isEmpty(this.filter.key)) {
        search = "&"+ this.filter.field + "=" + this.filter.key.trim()
      }

      if (this.filter.status != '') {
        search = search + "&active=" + this.filter.status;
      }

      let params = "?limit="+this.dataTable.perPage+"&page=" +this.dataTable.currentPage+"&sort_by="+this.dataTable.sort.field+"&order_by="+this.dataTable.sort.type+ search;

      this.axios.outlet.getOutletTradezoneList(uuid, params,{
          cancelToken: new CancelToken(function executor(c) {
            cancel = c;
          })
        },
        function(response){
          let langs = Object.keys(vm.$i18n.messages)
          for (let l in langs) {
            vm.statuses[langs[l]] = [
              {text: vm.$t('common.all', langs[l]), value: ''},
              {text: vm.$t('common.active', langs[l]), value: '1'},
              {text: vm.$t('common.inactive', langs[l]), value: '0'}
            ]
            vm.dataTable.items = response.data.data.items
            vm.dataTable.total = response.data.data.pagination.total
          }
        },
        function (error) {
          //your code
        });
    },

    /**
     * Link for edit outlet
    */

    editItem: function (tradezoneId) {
      this.$router.push({name: 'subtradezones', params: { id: tradezoneId }})
    },

    removeTradezone: function(tradezoneId) {
      let options = {
        html: true,
        okText: vm.$t('common.delete'),
        cancelText: vm.$t('common.cancel')
      }
      vm.$dialog.confirm(vm.$t('message.delete_confirm'), options)
        .then(function (dialog) {
            vm.axios.outlet.deleteTradezone(tradezoneId, function (response) {
                vm.$toastr.success(vm.$t('message.update_successful'), vm.$t('message.success'), {})
                vm.$bus.$emit('loading', 'none')
                vm.refreshData();
            }, function () {
                vm.$toastr.error(vm.$t('message.error'), vm.$t('message.success'), {})
                vm.$bus.$emit('loading', 'none')
            })
        })
        .catch(function () {
        
        })
    },
    
  },
 
  created: function () {
    this.outlet_config = this.$store.getters.config.gms.outlet
    this.debouncedInput = _.debounce(this.refreshData, 240)
    vm = this

    let clientNum = localStorage.getItem('clientID')
    this.axios.tenant.getClientDetail(clientNum, function(response){
      const clientItem  = response.data.data.item;
      vm.client = clientItem.id;
    });
    let CancelToken = vm.axios.CancelToken
    this.dataTable.source = CancelToken.source()
    let dataFields = []
    for (let i in this.dataTable.fields) {
      if (this.dataTable.fields[i].name != 'address') {
        dataFields.push(this.dataTable.fields[i])
      } else {
        if (this.outlet_config.config && this.outlet_config.config.show_address_on_list !== false) {
          dataFields.push(this.dataTable.fields[i])
        }
      }
    }

    this.dataTable.fields = dataFields
    for (let i in this.dataTable.fields) {
      if (this.dataTable.fields[i].filter != null && this.dataTable.fields[i].filter == true) {
        this.filter.options.push(this.dataTable.fields[i])
      }
      if (this.dataTable.fields[i].sort != null && this.dataTable.fields[i].sort == true && this.dataTable.sort.field == null) {
        this.dataTable.sort = {
          field: this.dataTable.fields[i].name,
          type: 'asc'
        }
      }
    }

    let filter = this.$session.get('filter', null)
    if (filter != null && this.$route.query && this.$route.query.rollback) {
      for (let i in filter.filter) {
        this.filter[i] = filter.filter[i]
      }
      for (let i in filter.dataTable) {
        this.dataTable[i] = filter.dataTable[i]
      }
    }
    vm.refreshData()
  },
  beforeDestroy: function () {
    this.$session.set('filter', {
      filter: this.filter,
      dataTable: {
        sort: {
          field: this.dataTable.sort.field,
          type: this.dataTable.sort.type
        },
        currentPage: this.dataTable.currentPage,
        perPage: this.dataTable.perPage
      }
    })
  },
  watch: {
    'filter.key': function (val) {
      this.debouncedInput()
    },
    'dataTable.currentPage': function (val) {
      this.refreshData()
    },
    'dataTable.perPage': function (val) {
      this.refreshData()
    },
    'filter.status': function (val) {
      this.refreshData()
    },
    'filter.code': function (val) {
      this.refreshData()
    }
  }
}
</script>

<style scoped>

  .file-select {
    margin-bottom: 0;
    vertical-align: inherit;
  }

  .file-select > .select-button {
    padding: 0.25rem 0.5rem;
    color: white;
    border-radius: .2rem;
    text-align: center;
    font-weight: bold;
    background: #0086FF !important;
    border-color: #0086FF !important;
    cursor: pointer;
    line-height: 1.25;
  }

  .file-select > .select-button > span {
    font-weight: normal;
    font-size: 0.76563rem;
    padding: 0;
  }

  .file-select > input[type="file"] {
    display: none;
  }
  .draw-map,
  .btn-primary {
    background: #0086FF !important;
    border-color: #0086FF !important;
    border-radius: 3px;
  }

   .remove-section{
    display: inline-block;
    cursor: pointer;
  }
  .remove-section > .text-main{
    font-size: 20px;
  }

  table button {
    border-radius: 4px;
  }
  .table thead th:nth-child(2){
    width: 100px;
  }
  .table thead th:nth-child(3){
    width: 100px;
  }
  .table thead th:nth-child(4){
    width: 115px;
  }
  .table thead th:nth-child(5){
    width: 150px;
  }
  .table thead th:nth-child(6){
    width: 110px;
  }
   .table thead th:nth-child(7){
    width: 125px;
  }
  .table thead th:nth-child(8){
    width: 125px;
  }
  .table thead th:nth-child(9){
    width: 125px;
  }
  .table thead th:nth-child(10){
    width: 110px;
  }
  .table thead th:nth-child(1){
    width: 100px;
  }
  .table thead th:last-child{
    width: 250px;
  }


</style>



// WEBPACK FOOTER //
// src/views/admin/tradezone/ListTradezone.vue